/** API BusinessUnit ↔ UI BU master fields. */

function resolveVillageCode(row) {
  return row?.village?.code ?? row?.villageCode ?? '';
}

function resolveVillageName(row) {
  return row?.village?.name ?? row?.villageName ?? row?.locality ?? '';
}

function placeFieldsFromApi(row) {
  return {
    googlePlaceId: row.googlePlaceId ?? '',
    formattedAddress: row.formattedAddress ?? '',
    locality: row.locality ?? '',
    sublocality: row.sublocality ?? '',
    taluka: row.taluka ?? '',
    district: row.district ?? '',
    state: row.state ?? '',
    country: row.country ?? '',
    pin: row.pin ?? '',
    latitude: row.latitude != null ? Number(row.latitude) : null,
    longitude: row.longitude != null ? Number(row.longitude) : null,
  };
}

function placeFieldsToApi(ui) {
  return {
    googlePlaceId: ui.googlePlaceId || null,
    formattedAddress: ui.formattedAddress || null,
    locality: ui.locality || null,
    sublocality: ui.sublocality || null,
    taluka: ui.taluka || null,
    district: ui.district || null,
    state: ui.state || null,
    country: ui.country || null,
    pin: ui.pin || null,
    latitude: ui.latitude != null ? Number(ui.latitude) : null,
    longitude: ui.longitude != null ? Number(ui.longitude) : null,
  };
}

export function businessUnitFromApi(row) {
  if (!row) return null;
  const villageDbId = row.villageId != null ? Number(row.villageId) : null;
  // `code` was dropped from backend; keep `buId` as a stable display/key from numeric id.
  const idKey = row.id != null ? String(row.id) : '';
  return {
    id: row.id,
    buId: row.code ?? idKey,
    shortName: row.shortName ?? '',
    fullNameGst: row.fullNameGst ?? '',
    address1: row.address1 ?? '',
    address2: row.address2 ?? '',
    ...placeFieldsFromApi(row),
    villageId: resolveVillageCode(row),
    villageDbId,
    villageName: resolveVillageName(row),
    active: row.isActive !== false,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
  };
}

export function businessUnitToApi(ui) {
  if (!ui) return null;
  const villageIdRaw = ui.villageDbId ?? ui.villageId;
  const villageId = villageIdRaw === '' || villageIdRaw == null ? null : Number(villageIdRaw);
  return {
    shortName: ui.shortName,
    fullNameGst: ui.fullNameGst || null,
    address1: ui.address1 || null,
    address2: ui.address2 || null,
    ...placeFieldsToApi(ui),
    villageId: Number.isFinite(villageId) ? villageId : null,
    isActive: ui.active !== false,
  };
}

export function siteFromApi(row) {
  if (!row) return null;
  const villageDbId = row.villageId != null ? Number(row.villageId) : null;
  const buDbId = row.buId != null ? Number(row.buId) : null;
  const idKey = row.id != null ? String(row.id) : '';
  const buKey =
    row.businessUnit?.code ||
    (row.businessUnit?.id != null ? String(row.businessUnit.id) : '') ||
    (buDbId != null ? String(buDbId) : '');
  return {
    id: row.id,
    siteId: row.code ?? idKey,
    buId: buKey,
    buDbId,
    siteName: row.siteName ?? '',
    projectOperation: row.projectOperation ?? '',
    address1: row.address1 ?? '',
    address2: row.address2 ?? '',
    ...placeFieldsFromApi(row),
    villageId: resolveVillageCode(row),
    villageDbId,
    villageName: resolveVillageName(row),
    pinOverride: row.pinOverride ?? '',
    active: row.isActive !== false,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
  };
}

export function siteToApi(ui) {
  if (!ui) return null;
  const buId = Number(ui.buDbId ?? ui.buId);
  const villageIdRaw = ui.villageDbId ?? ui.villageId;
  const villageId = villageIdRaw === '' || villageIdRaw == null ? null : Number(villageIdRaw);
  return {
    buId: Number.isFinite(buId) ? buId : undefined,
    siteName: ui.siteName,
    projectOperation: ui.projectOperation || null,
    address1: ui.address1 || null,
    address2: ui.address2 || null,
    ...placeFieldsToApi(ui),
    villageId: Number.isFinite(villageId) ? villageId : null,
    pinOverride: ui.pinOverride || ui.pin || null,
    isActive: ui.active !== false,
  };
}
